export default {
  title: {
    id: 'review_funnel_app_incentive_block_title',
    defaultMessage: 'Easier in the app.',
  },
  subtitle: {
    id: 'review_funnel_app_incentive_block_subtitle',
    defaultMessage:
      'Scan the QR code and download the Back Market app for care tips, price drops, order tracking, and more.',
  },
} as const
